module.exports = new __parcel__URL__("hud_army_button.f6e787da.png").toString();